import { render } from "./WebLinks.vue?vue&type=template&id=5338e43a&scoped=true"
import script from "./WebLinks.vue?vue&type=script&lang=js"
export * from "./WebLinks.vue?vue&type=script&lang=js"

import "./WebLinks.vue?vue&type=style&index=0&id=5338e43a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5338e43a"]])

export default __exports__